export default __webpack_public_path__ + "static/media/icon-back-arrow-left.951ba7f7.svg";